import React, { useState, useEffect, useRef } from "react";
import { DataTable } from "primereact/datatable";
import { Column } from "primereact/column";
import { ProgressSpinner } from 'primereact/progressspinner';
import { Button } from "primereact/button";
import { InputText } from "primereact/inputtext";
import { srBodyTemplate, CommonBodyForTable, commonFormDialogFooter, DateMonthBodyForTable } from "../Common/CommonComponents";
import ApiServices from "../../service/api/ApiServices";
import { Dialog } from "primereact/dialog";
import { CommonForDetails } from "../CRM/Leads";
import { Toast } from "primereact/toast";
import { failureToast, successToast } from "../Common/CommonFunctions";
import { Toolbar } from "primereact/toolbar";
import { billingTypeOptions, paymentTermOptions, paymentTypeOptions, prefixOptions, rentleOptions, subScriptionOptions, entityOptions, defaultValues, billingDefault, dispensingOptions, paidBeverageSetting, extentionPeriodOptions } from "./Constants";
import { Dropdown } from "primereact/dropdown";
import { Checkbox } from "primereact/checkbox";
import { GSFSchemeSelect } from "./GSFSchemeSelect";
const saved = localStorage.getItem("user");

// Parse the saved user data from localStorage.
// This is typically used to get user information or authentication details.
const initialValue = JSON.parse(saved);

// Create an instance of ApiServices to use its methods for API calls.
// Assuming ApiServices is a class that handles API requests.
const apiServices = new ApiServices()

/** * Customers component to display a list of Customers in a data table.
 * It fetches the Customers data from the API and displays it in a paginated table format.
 * It also includes a search functionality to filter the Customers based on their names or other attributes.
 */
export const GSFCustomerOnboard = ({ preOrderData, clearPreOrderData }, props,) => {
    const [customerList, setCustomersList] = useState(null)
    const [loading, setLoading] = useState(false)
    const [globalFilter, setGlobalFilter] = useState('');
    const [addCustomerDialog, setAddCustomerDialog] = useState(false);
    const [editedCustomer, setEditedCustomer] = useState(null);
    const [selectedPrefix, setSelectedPrefix] = useState(null);
    const [selectedState, setSelectedState] = useState(null);
    const [states, setStates] = useState([]);
    const [countries, setCountries] = useState([]);
    const [selectedCountry, setSelectedCountry] = useState(null);
    const [cities, setCities] = useState([]);
    const [selectedCity, setSelectedCity] = useState(null);
    const [selectedCountry2, setSelectedCountry2] = useState(null);
    const [selectedState2, setSelectedState2] = useState(null);
    const [selectedCity2, setSelectedCity2] = useState(null);
    const [isShippingSameAsBilling, setIsShippingSameAsBilling] = useState(false);
    const [salesMembersList, setSalesMembersList] = useState(null);
    const [confirmDeleteDialog, setConfirmDeleteDialog] = useState(false)
    const [selectedSalesCustomer, setSelectedSalesCustomer] = useState(null)
    const [openSchemeDialog, setOpenSchemeDialog] = useState(false);
    const [orderData, setOrderData] = useState(null);
    const [customerDetailsDialog, setCustomerDetailsDialog] = useState(false);
    const [disableSubmit, setSubmitDisabled] = useState(false)

    useEffect(() => {

        if (preOrderData) {
            // Personal Info
            setPersonelInformation({
                prefix: preOrderData.prefix || "Mr.",
                first_name: preOrderData.first_name || "",
                last_name: preOrderData.last_name || "",
                phone_number: preOrderData.phone_number || "",
                email_id: preOrderData.email_id || "",
            });

            // Billing Details (company_name, address)
            setBillingDetails({
                company_name: preOrderData.company_name || "",
                address: preOrderData.location || "",  // ✅ mapping location → billing address
                country: "",   // not present in props
                state: "",
                city: "",
                pincode: "",
            });

            // Shipping Details (if same as billing for now)
            setShippingDetails({
                facility_name: preOrderData.company_name || "",
                address: preOrderData.location || "",
                country: "",
                state: "",
                city: "",
                pincode: "",
            });

            // Signing Authority (not in props → keep blank)
            setSigningAuthorityDetails({
                signing_authority_person_first_name: "",
                signing_authority_person_last_name: "",
                signing_authority_mobile: "",
                signing_authority_email: "",
                signing_authority_designation: ""
            });

            // Commercial Information (few values exist)
            setCommercialInformation({
                packetwise: "PacketWise",
                packet_cost: "",
                dispense_quantity: "",
                subscription_type: "FREE",
                speciality_cost: "",
                billing_type: "",
                billing_type_value: "Packetwise",
            });

            // Payment Terms
            setPaymentTermsInformation({
                mode: "PREPAID", // not provided, default
                payment_term: "",
                beverage_dispensing_option: "FREE",
                Prepaid_Payment_Type_in_word: "Prepaid"
            });

            // Selected Payment Mode
            setSelectedPaymentMode({
                name: "Prepaid",
                code: "PREPAID"
            });

            setCustomerDetailsDialog(true)
        }
    }, [preOrderData]);



    const [personelInformation, setPersonelInformation] = useState({
        first_name: '',
        last_name: '',
        phone_number: '',
        email_id: ''
    });

    const [billingDetails, setBillingDetails] = useState({
        company_name: '',
        address: '',
        country: '',
        state: '',
        city: '',
        pincode: '',
    });

    const [shippingDetails, setShippingDetails] = useState({
        facility_name: '',
        address: '',
        country: '',
        state: '',
        city: '',
        pincode: '',
    });

    const [signingAuthorityDetails, setSigningAuthorityDetails] = useState({
        signing_authority_person_first_name: '',
        signing_authority_person_last_name: '',
        signing_authority_mobile: '',
        signing_authority_email: '',
        signing_authority_designation: ''
    });

    const [commercialInformation, setCommercialInformation] = useState({
        packetwise: 'PacketWise',
        packet_cost: '',
        dispense_quantity: '',
        subscription_type: 'FREE',
        speciality_cost: '',
        billing_type: '',
        billing_type_value: 'PacketWise',
    });

    const [paymentTermsInformation, setPaymentTermsInformation] = useState({
        mode: 'PREPAID',
        payment_term: '',
        beverage_dispensing_option: 'FREE',
        Prepaid_Payment_Type_in_word: "Prepaid"
    });

    const [selectedPaymentMode, setSelectedPaymentMode] = useState({ name: "Prepaid", code: "PREPAID" });

    const dataRef = useRef(null);

    // Create a ref for the toast component to show notifications.
    const toast = useRef(null);

    const tableStyle = { overflowX: 'scroll', width: '100%' };

    const exportCSV = () => {
        dataRef.current.exportCSV();
    }

    const header = (
        <div className="table-header">
            <span className="p-input-icon-right">
                <h6 className="p-mt-3 p-mr-5">Customers</h6>
            </span>
            <span className="p-input-icon-left">
                <div className="p-inputgroup">
                    <Button className='custom-group-btn' icon="pi pi-search" />
                    <InputText type="search" onInput={(e) => setGlobalFilter(e.target.value)} placeholder="Search..." />
                    <Button className='custom-group-btn p-button-rounded p-m-2' onClick={() => { exportCSV(dataRef) }} icon="pi pi-download"></Button>
                </div>
            </span>
        </div>
    )

    /**
     * Function to fetch Customers data from the API
     * and update the state with the fetched data.
     */
    // const getCustomers = async (data = {}) => {
    //     setLoading(true)
    //     let obj = {}
    //     if (data) {
    //         obj.salesPerson_id = data.salesPerson_id
    //     }
    //     const response = await apiServices.getGSFCustomers(obj)   // Assuming this API returns the Customers data
    //     if (response?.data?.response_obj.length > 0) {
    //         setCustomersList(response.data.response_obj)
    //     } else {
    //         setCustomersList([])
    //     }
    //     setLoading(false)
    // }

    /** * Function to set the address details for the customer.
     * 
     * 
     * @param {Object} e - The event object containing the input field data.
     * */
    const toggleBillingAddress = () => {
        setIsShippingSameAsBilling(prev => {
            const sameAsBilling = !prev;

            if (sameAsBilling) {
                // Copy billing details to shipping
                setShippingDetails({ ...billingDetails });
                setSelectedCity2(selectedCity);
                setSelectedState2(selectedState);
                setSelectedCountry2(selectedCountry);
            } else {
                // Reset shipping details
                setShippingDetails({
                    address: '',
                    country: '',
                    state: '',
                    city: '',
                    pincode: '',
                });
                setSelectedCity2(null);
                setSelectedState2(null);
                setSelectedCountry2(null);
            }

            return sameAsBilling;
        });
    };

    /**
     * Function to fetch sales members data from the API
     * and update the state with the fetched data.
     */
    const getSalesMembers = async (data = {}) => {
        setLoading(true)
        if (preOrderData && preOrderData.salesPerson_id) {
            data.salesPerson_id = preOrderData.salesPerson_id;

            const response = await apiServices.getGSFSalesMembers(data);
            console.log(response, data);

            if (response?.data?.response_obj.length) {
                // pick the first matched sales person
                setSalesMembersList(response.data.response_obj[0]);
            } else {
                setSalesMembersList(null);
            }
            setLoading(false);
        }
    };


    /** * Function to render the action buttons for each row in the data table.
     * It includes Edit and View buttons with appropriate styles and actions.
     * @param {Object} rowData - The data of the current row.
     * @returns JSX element containing action buttons.
     */


    const hideDialog = () => {
        setAddCustomerDialog(false);
        setEditedCustomer(null);
        setPersonelInformation({});
        setCommercialInformation({});
        setSigningAuthorityDetails({});
        setBillingDetails({});
        setShippingDetails({});
        setPaymentTermsInformation({});
        setCustomerDetailsDialog(false)
        clearPreOrderData()

    }

    const customerDialogFooter = (
        <>
            <Button label="Close" icon="pi pi-times" className="p-button-danger p-mr-2 p-mb-2" onClick={hideDialog} />
            {disableSubmit ? <Button label="Submit" type='submit' form='customer-form' icon="pi pi-check" disabled className="p-button-success p-mr-2 p-mb-2" />
                : <Button label="Submit" type='submit' form='customer-form' icon="pi pi-check" className="p-button-success p-mr-2 p-mb-2" />
            }
        </>
    );

    const onCustomerSubmit = async (e) => {
        e.preventDefault();

        let data = {
            shipping_address: shippingDetails,
            billing_address: billingDetails,
            payment_terms: paymentTermsInformation,
            addedby_salesPerson_id: initialValue.id,
            prefix: selectedPrefix?.name || "",
            ...personelInformation,
            ...commercialInformation,
            ...signingAuthorityDetails,
            ...editedCustomer,
            legal_entity_name: editedCustomer?.legal_entity || "",
            salesMember_zohoId: salesMembersList?.salesMember_zohoId,
            salesMember_MasterzohoId: salesMembersList?.salesMember_MasterzohoId,
            addedby_salesPerson_id: salesMembersList?.salesPerson_id || initialValue.id,
            salesPerson_id: salesMembersList?.salesPerson_id || initialValue.id,
            salesPerson_objectId: salesMembersList?.id,
        };

        setLoading(true);
        const res = await apiServices.createGSFCustomerForm(data);
        debugger
        if (res?.data?.response_code) {
            successToast(toast, "Customer Created Successfully");
        } else {
            failureToast(toast, `Failed to Create, ${res?.data?.msg}`);
        }

        setOrderData(res?.data?.response_obj || null);
        setAddCustomerDialog(false);
        setEditedCustomer(null);
        // getCustomers();
        setCustomerDetailsDialog(true)

        setOpenSchemeDialog(true);

        setSubmitDisabled(true)

        setLoading(false);
    };



    /** * Function to handle changes in the personal information input fields.
     * It updates the personelInformation state with the new input value.
     * @param {Object} e - The event object containing the input field data.
     * */
    const changePersonelInformation = (e) => {
        // Update the editedCustomer state with the new input value
        setPersonelInformation({ ...personelInformation, [e.target.name]: e.target.value })
    }

    /** * Function to handle changes in the billing details input fields.
     * It updates the billingDetails state with the new input value.
     */
    const billingDetailsChange = (e) => {
        // Update the billingDetails state with the new input value
        setBillingDetails({ ...billingDetails, [e.target.name]: e.target.value })
    }

    /** * Function to handle changes in the input fields of the customer form.
     * It updates the state with the new input value and handles country, state, and city selections.
     * @param {Object} e - The event object containing the input field data.
     */
    const changeInputs = async (e) => {
        // Update the editedCustomer state with the new input value
        if (e.target.name == 'country') {
            setSelectedCountry(e.value)
            e.target.id == 'country1' ? setBillingDetails({ ...billingDetails, country: e.value.name }) : setShippingDetails({ ...shippingDetails, country: e.value.name });
            const state = await getStates({ country_id: e.value.id })
            setStates(state)
            setSelectedCity(null)
            setSelectedState(null)
            setCities(null)
            if (e.target.id == 'country1') {
                setSelectedCountry(e.value)
            } else {
                setSelectedCountry2(e.value)
            }
        }

        if (e.target.name == 'state') {
            setSelectedState(e.value)
            e.target.id == 'state1' ? setBillingDetails({ ...billingDetails, state: e.value.name }) : setShippingDetails({ ...shippingDetails, state: e.value.name });
            const city = await getCities({ state_id: e.value.id })
            setCities(city)
            if (e.target.id == 'state1') {
                setSelectedState(e.value)
            } else {
                setSelectedState2(e.value)
            }
        }

        if (e.target.name == 'city') {
            e.target.id == 'city1' ? setBillingDetails({ ...billingDetails, city: e.value.name }) : setShippingDetails({ ...shippingDetails, city: e.value.name });
            if (e.target.id == 'city1') {
                setSelectedCity(e.value)
            } else {
                setSelectedCity2(e.value)
            }
        }

        setEditedCustomer({ ...editedCustomer, [e.target.name]: e.target.value })
    }


    const changeShippingInputs = async (e) => {
        // Update the editedCustomer state with the new input value
        setShippingDetails({ ...shippingDetails, [e.target.name]: e.target.value })
    }

    const signingAuthorityChange = (e) => {
        // Update the editedCustomer state with the new input value
        setSigningAuthorityDetails({ ...signingAuthorityDetails, [e.target.name]: e.target.value })
    }

    const commercialInformationChange = (e) => {
        if (e.target.name === 'billing_type_value') {
            setCommercialInformation({ ...commercialInformation, [e.target.name]: e.target.value, billing_type: e.value.code })
            console.log(commercialInformation);
            return;
        }
        setCommercialInformation({ ...commercialInformation, [e.target.name]: e.target.value })
    }

    const paymentTermsChange = (e) => {
        if (e.target.name === 'mode') {
            setSelectedPaymentMode(e.value)
            setPaymentTermsInformation({ ...paymentTermsInformation, mode: e.value.name })
            return
        }
        setPaymentTermsInformation({ ...paymentTermsInformation, [e.target.name]: e.target.value })
    }

    /** * Function to fetch states and cities based on the selected country.
     * It updates the states and cities state variables accordingly.
     */
    const getStatesData = async (data) => {
        // console.log(data);
        getCountry();
        const state = await getStates({ country_id: '101' })
        setStates(state)
        const defaultState = state.filter((x) => { return (x.name == data?.state?.name) });
        if (defaultState?.length > 0) {
            setSelectedState(defaultState[0])
            setSelectedState2(defaultState[0])
            const city = await getCities({ state_id: defaultState[0].id })
            setCities(city)
            const defaultCity = city.filter((x) => { return (x.name == data?.city?.name) });
            setSelectedCity(defaultCity?.length > 0 ? defaultCity[0] : null)
            setSelectedCity2(defaultCity?.length > 0 ? defaultCity[0] : null);
        }
    }

    /** * Function to fetch states from the API based on the selected country.
     * It returns the list of states.
     * @param {Object} data - The data object containing the country ID.
     * @returns {Array} - The list of states.
     * */
    const getStates = async (data) => {
        const response = await apiServices.getState(data);
        return response?.data;
    }

    /** * Function to fetch countries from the API.
     * It updates the countries state variable with the fetched data.
     */
    const getCountry = async () => {
        const response = await apiServices.getCountry();
        setCountries(response?.data)
    }

    /** * Function to fetch cities based on the selected state.
     * It returns the list of cities.
     * @param {Object} data - The data object containing the state ID.
     * @returns {Array} - The list of cities.
     */
    const getCities = async (data) => {
        const response = await apiServices.getCity(data);
        return response?.data;
    }

    useEffect(() => {
        // getCustomers(props?.data)
        getStatesData()
        getSalesMembers({});
    }, [props])

    return (
        <>
            {!openSchemeDialog ? (
                <div className="p-grid crud-demo">
                    <div className="p-col-12">
                        <div className="card">
                            <Toast ref={toast} position="center" />
                            <Dialog visible={customerDetailsDialog} style={{ width: '900px' }} header={`Customer Details`} modal className="p-fluid" footer={customerDialogFooter} onHide={hideDialog} maximizable={true} blockScroll={true}>
                                <form onSubmit={onCustomerSubmit} id="customer-form" className="p-fluid p-grid">
                                    <div className="p-fluid p-grid" style={{ backgroundColor: "#ffffffff" }}>
                                        <div className="p-col-12">
                                            <h6>Sales Person</h6>
                                            <hr />
                                        </div>
                                        <div className="p-col-6">
                                            <div className="p-field flex flex-col gap-1">
                                                <label className="font-semibold text-gray-700"><strong>SalesPerson Name : {salesMembersList
                                                    ? `${salesMembersList.first_name || ""} ${salesMembersList.last_name || ""}`.trim()
                                                    : "Not Found"}</strong></label>
                                            </div>
                                        </div>

                                        {/* ------------------- Personal Information ------------------- */}
                                        <div className="p-col-12">
                                            <h6>Personal Information</h6>
                                            <hr />
                                        </div>
                                        <div className="p-col-2">
                                            <div className="p-field">
                                                <label htmlFor="prefix">Prefix</label>
                                                <Dropdown
                                                    autoFocus
                                                    id="prefix"
                                                    name="prefix"
                                                    value={selectedPrefix}
                                                    onChange={(e) => setSelectedPrefix(e.value)}
                                                    options={prefixOptions}
                                                    optionLabel="name"
                                                    placeholder="Prefix"
                                                    className="multiselect-custom"
                                                    required
                                                />
                                            </div>
                                        </div>
                                        <div className="p-field p-col-5">
                                            <label htmlFor="first_name">First Name</label>
                                            <InputText
                                                id="first_name"
                                                name="first_name"
                                                placeholder="Customer First Name"
                                                onChange={changePersonelInformation}
                                                value={personelInformation?.first_name}
                                                required
                                            />
                                        </div>
                                        <div className="p-field p-col-5">
                                            <label htmlFor="last_name">Last Name</label>
                                            <InputText
                                                id="last_name"
                                                name="last_name"
                                                placeholder="Customer Last Name"
                                                onChange={changePersonelInformation}
                                                value={personelInformation?.last_name}
                                                required
                                            />
                                        </div>
                                        <div className="p-field p-col-4">
                                            <label htmlFor="phone_number">Contact</label>
                                            <InputText
                                                id="phone_number"
                                                name="phone_number"
                                                placeholder="Customer Contact"
                                                minLength={10}
                                                maxLength={10}
                                                onChange={changePersonelInformation}
                                                disabled={preOrderData?.phone_number ? true : false}
                                                defaultValue={preOrderData ? preOrderData.phone_number : ""}
                                                value={personelInformation?.phone_number}
                                                onKeyPress={(e) => {
                                                    if (!/[0-9]/.test(e.key)) {
                                                        e.preventDefault();
                                                    }
                                                }}
                                                required
                                            />
                                        </div>
                                        <div className="p-field p-col-4">
                                            <label htmlFor="email_id">Email</label>
                                            <InputText
                                                id="email_id"
                                                type="email"
                                                name="email_id"
                                                placeholder="Customer Email"
                                                onChange={changePersonelInformation}
                                                value={personelInformation?.email_id}
                                                required
                                            />
                                        </div>
                                    </div>

                                    {/* ------------------- Billing Information ------------------- */}
                                    <div className="p-fluid p-grid" style={{ backgroundColor: "#ffffffff" }}>
                                        <div className="p-col-12">
                                            <h6>Billing Information </h6>
                                            <hr />
                                        </div>
                                        <div className="p-field p-col-4">
                                            <label htmlFor="company_name">Business Name</label>
                                            <InputText
                                                id="company_name"
                                                name="company_name"
                                                placeholder="Business Name"
                                                onChange={billingDetailsChange}
                                                value={billingDetails?.company_name}
                                                required
                                            />
                                        </div>
                                        <div className="p-field p-col-4">
                                            <label htmlFor="country1">Country</label>
                                            <Dropdown id="country1" name="country" value={selectedCountry} onChange={changeInputs} autoFocus required options={countries} optionLabel="name" placeholder="Select Country" filter className="multiselect-custom" />
                                        </div>
                                        <div className="p-field p-col-4">
                                            <label htmlFor="state1">State</label>
                                            <Dropdown id="state1" name="state" value={selectedState} onChange={changeInputs} autoFocus required options={states} optionLabel="name" placeholder="Select State" filter className="multiselect-custom" />
                                        </div>
                                        <div className="p-field p-col-4">
                                            <label htmlFor="city1">City</label>
                                            <Dropdown id="city1" name="city" value={selectedCity} onChange={changeInputs} autoFocus required options={cities} optionLabel="name" placeholder="Select City" filter className="multiselect-custom" />
                                        </div>
                                        <div className="p-field p-col-4">
                                            <label htmlFor="address">Billing Address</label>
                                            <InputText
                                                id="address"
                                                name="address"
                                                placeholder="Billing Address"
                                                onChange={billingDetailsChange}
                                                value={billingDetails?.address}
                                                required
                                            />
                                        </div>
                                        <div className="p-field p-col-4">
                                            <label htmlFor="pincode">Billing Pincode</label>
                                            <InputText
                                                id="pincode"
                                                type="text"
                                                name="pincode"
                                                minLength={6}
                                                maxLength={6}
                                                placeholder="Billing Pincode"
                                                onChange={billingDetailsChange}
                                                value={billingDetails?.pincode}
                                                required
                                                onKeyPress={(e) => {
                                                    if (!/[0-9]/.test(e.key)) {
                                                        e.preventDefault();
                                                    }
                                                }}
                                            />
                                        </div>
                                        {/* <div className="p-field p-col-4">
                                        <label htmlFor="pincode">Billing Pincode</label>
                                        <InputText id="pincode" type="text" name='pincode' minLength={6} maxLength={6} placeholder='Billing Pincode' autoComplete="off" onChange={billingDetailsChange} value={billingDetails?.pincode} autoFocus required onKeyPress={(e) => {
                                            if (!/[0-9]/.test(e.key)) {
                                                e.preventDefault();
                                            }
                                        }} />
                                    </div> */}
                                        <div className="p-field p-col-4">
                                            <label htmlFor="gst_no">GST Number <small className="p-error">(example : 18AABCU9603R1ZM) </small></label>
                                            <InputText id="gst_no" name="gst_no" placeholder="GST No" minLength={15} maxLength={15} pattern="^[0-9]{2}[A-Z]{5}[0-9]{4}[A-Z]{1}[1-9A-Z]{1}Z[0-9A-Z]{1}$" autoComplete="off" onChange={changeInputs} value={editedCustomer?.gst_no} autoFocus />
                                        </div>
                                        <div className="p-field p-col-4">
                                            <label htmlFor="panCard">PAN Card <small className="p-error">(exmaple : ABCTY1234D)</small></label>
                                            <InputText id="panCard" name='pan' placeholder='PAN Card' pattern="[a-zA-Z]{5}[0-9]{4}[a-zA-Z]{1}" autoComplete="off" onChange={changeInputs} value={editedCustomer?.pan} autoFocus required />
                                        </div>
                                        <div className="p-field p-col-4">
                                            <label htmlFor="legal_entity">Legal Entity</label>
                                            <InputText id="legal_entity" name='legal_entity' placeholder='Legal Entity' autoComplete="off" onChange={changeInputs} value={editedCustomer?.legal_entity} autoFocus required />
                                        </div>
                                        <div className="p-col-12">
                                            <h6>Shipping Information ( <small> <Checkbox checked={isShippingSameAsBilling} onChange={toggleBillingAddress} /> Note: If the shipping address is the same as the billing address, please check the box below. <span style={{ color: "red" }} >
                                            </span> )</small></h6>
                                            <hr />
                                        </div>
                                        <div className="p-field p-col-4">
                                            <label htmlFor="facility_name">Facility Name</label>
                                            <InputText id="facility_name" name='facility_name' placeholder='Facility Name' autoComplete="off" onChange={changeShippingInputs} value={editedCustomer?.facility_name} autoFocus required />
                                        </div>
                                        <div className="p-field p-col-4">
                                            <label htmlFor="country2">Country</label>
                                            <Dropdown id="country2" name="country" value={selectedCountry2} onChange={changeInputs} options={countries} optionLabel="name" placeholder="Select Country" filter className="multiselect-custom" required />
                                        </div>
                                        <div className="p-field p-col-4">
                                            <label htmlFor="state2">State</label>
                                            <Dropdown id="state2" name="state" value={selectedState2} onChange={changeInputs} options={states} optionLabel="name" placeholder="Select State" filter className="multiselect-custom" required />
                                        </div>
                                        <div className="p-field p-col-4">
                                            <label htmlFor="city2">City</label>
                                            <Dropdown id="city2" name="city" value={selectedCity2} onChange={changeInputs} options={cities} optionLabel="name" placeholder="Select City" filter className="multiselect-custom" required />
                                        </div>
                                        <div className="p-field p-col-4">
                                            <label htmlFor="shipping_address">Shipping Address</label>
                                            <InputText id="shipping_address" name='address' placeholder='Shipping Address' autoComplete="off" onChange={changeShippingInputs} value={shippingDetails?.address} required />
                                        </div>
                                        <div className="p-field p-col-4">
                                            <label htmlFor="shipping_pincode">Shipping Pincode</label>
                                            <InputText id="shipping_pincode" minLength={6} maxLength={6} name='pincode' placeholder='Shipping Pincode' autoComplete="off" onChange={changeShippingInputs} value={shippingDetails?.pincode} required onKeyPress={(e) => {
                                                if (!/[0-9]/.test(e.key)) {
                                                    e.preventDefault();
                                                }
                                            }} />
                                        </div>
                                        <div className="p-field p-col-4">
                                            <label htmlFor="lattitude">Lattitude</label>
                                            <InputText id="lattitude" name='lattitude' placeholder='Lattitude' autoComplete="off" onChange={changeInputs} value={editedCustomer?.lattitude} required onKeyPress={(e) => {
                                                if (!/[0-9.]/.test(e.key)) {
                                                    e.preventDefault();
                                                }
                                            }} />
                                        </div>
                                        <div className="p-field p-col-4">
                                            <label htmlFor="longitude">Longitude</label>
                                            <InputText id="longitude" name='longitude' placeholder='Longitude' autoComplete="off" onChange={changeInputs} value={editedCustomer?.longitude} required onKeyPress={(e) => {
                                                if (!/[0-9.]/.test(e.key)) {
                                                    e.preventDefault();
                                                }
                                            }} />
                                        </div>
                                    </div>
                                    <div className="p-fluid p-grid" style={{ backgroundColor: "#ffffffff" }}>
                                        <div className="p-col-12">
                                            <h6>Signing Authority Information</h6>
                                            <hr />
                                        </div>
                                        <div className="p-field p-col-4">
                                            <label htmlFor="signing_authority_person_first_name">Signing Authority First Name</label>
                                            <InputText id="signing_authority_person_first_name" name='signing_authority_person_first_name' placeholder='Signing Authority First Name' autoComplete="off" onChange={signingAuthorityChange} value={signingAuthorityDetails?.signing_authority_person_first_name} autoFocus required />
                                        </div>
                                        <div className="p-field p-col-4">
                                            <label htmlFor="signing_authority_person_last_name">Signing Authority Last Name</label>
                                            <InputText id="signing_authority_person_last_name" name='signing_authority_person_last_name' placeholder='Signing Authority Last Name' autoComplete="off" onChange={signingAuthorityChange} value={signingAuthorityDetails?.signing_authority_person_last_name} required />
                                        </div>
                                        <div className="p-field p-col-4">
                                            <label htmlFor="signing_authority_mobile">Signing Authority Mobile</label>
                                            <InputText id="signing_authority_mobile" minLength={10} maxLength={10} name='signing_authority_mobile' placeholder='Signing Authority Mobile' autoComplete="off" onChange={signingAuthorityChange} value={signingAuthorityDetails?.signing_authority_mobile} required onKeyPress={(e) => {
                                                if (!/[.0-9]/.test(e.key)) {
                                                    e.preventDefault();
                                                }
                                            }} />
                                        </div>
                                        <div className="p-field p-col-4">
                                            <label htmlFor="signing_authority_email">Signing Authority Email</label>
                                            <InputText type="email" id="signing_authority_email" name='signing_authority_email' placeholder='Signing Authority Email' autoComplete="off" onChange={signingAuthorityChange} value={signingAuthorityDetails?.signing_authority_email} required />
                                        </div>
                                        <div className="p-field p-col-4">
                                            <label htmlFor="signing_authority_designation">Signing Authority Designation</label>
                                            <InputText id="signing_authority_designation" name='signing_authority_designation' placeholder='Signing Authority Designation' autoComplete="off" onChange={signingAuthorityChange} value={signingAuthorityDetails?.signing_authority_designation} required />
                                        </div>
                                    </div>
                                    <div className="p-fluid p-grid" style={{ backgroundColor: "#ffffffff" }}>
                                        <div className="p-col-12">
                                            <h6>Commercial Information</h6>
                                            <hr />
                                        </div>
                                        {/* <div className="p-field p-col-4">
                                        <label htmlFor="billing_type_value">Billing Type</label>
                                        <InputText id="billing_type_value" name="billing_type_value" placeholder='Packetwise' disabled onChange={commercialInformationChange} value={commercialInformation.billing_type_value} options={billingTypeOptions} optionLabel="name" placeholder="Select Billing Type" filter className="multiselect-custom" required />
                                    </div> */}
                                        {/* <div className="p-field p-col-4">
                                    <label htmlFor="packetwise">Packetwise</label>
                                    <InputText id="packetwise" name='packetwise' placeholder='Packetwise' disabled autoComplete="off" onChange={commercialInformationChange} value={commercialInformation?.packetwise} required />
                                </div> */}
                                        {/* <div className="p-field p-col-4">
                                    <label htmlFor="packet_cost">Per Packet Rate</label>
                                    <InputText id="packet_cost" type="number" min={0} name='packet_cost' placeholder='Per Packet Rate' autoComplete="off" onChange={commercialInformationChange} value={commercialInformation?.packet_cost} required onInput={(e) => {
                                        e.target.value = e.target.value.replace(/[^0-9]/g, ""); // only digits allowed
                                    }} />
                                </div> */}
                                        {/* <div className="p-field p-col-4">
                                    <label htmlFor="dispense_quantity">Beverage Quantity</label>
                                    <InputText id="dispense_quantity" type="number" min={0} name='dispense_quantity' placeholder='Beverage Quantity' autoComplete="off" onChange={commercialInformationChange} value={commercialInformation?.dispense_quantity} required onInput={(e) => {
                                        e.target.value = e.target.value.replace(/[^0-9]/g, ""); // only digits allowed
                                    }} />
                                </div> */}
                                        <div className="p-field p-col-4">
                                            <label htmlFor="subscription_type">Subscription Type</label>
                                            <InputText id="subscription_type" name='subscription_type' placeholder='Subscription Type' disabled autoComplete="off" onChange={commercialInformationChange} value={commercialInformation?.subscription_type} required />
                                        </div>
                                        <div className="p-field p-col-4">
                                            <label htmlFor="speciality_cost">Speciality Cost</label>
                                            <InputText id="speciality_cost" type="number" min={0} name='speciality_cost' placeholder='Speciality Cost' autoComplete="off" onChange={commercialInformationChange} value={commercialInformation?.speciality_cost} onInput={(e) => {
                                                e.target.value = e.target.value.replace(/[^0-9.]/g, ""); // only digits allowed
                                            }} />
                                        </div>
                                    </div>
                                    <div className="p-fluid p-grid" style={{ backgroundColor: "#ffffffff" }}>
                                        <div className="p-col-12">
                                            <h6>Payment Terms</h6>
                                            <hr />
                                        </div>
                                        <div className="p-field p-col-4">
                                            <label htmlFor="mode">Mode</label>
                                            <Dropdown id="mode" name="mode" disabled value={selectedPaymentMode} onChange={paymentTermsChange} options={paymentTermOptions} optionLabel="name" placeholder="Select Mode" filter className="multiselect-custom" required />
                                        </div>
                                        {/* <div className="p-field p-col-4">
                                    <label htmlFor="payment_term">Payment Term</label>
                                    <InputText id="payment_term" name='payment_term' placeholder='Payment Term' disabled autoComplete="off" onChange={paymentTermsChange} value={paymentTermsInformation?.payment_term} autoFocus required />
                                </div> */}
                                        <div className="p-field p-col-4">
                                            <label htmlFor="beverage_dispensing_option">Beverage Dispensing Option</label>
                                            <InputText id="beverage_dispensing_option" name='beverage_dispensing_option' disabled placeholder='Beverage Dispensing Option' autoComplete="off" onChange={paymentTermsChange} value={paymentTermsInformation?.beverage_dispensing_option} required />
                                        </div>
                                    </div>
                                </form>
                            </Dialog>

                            {/* {openSchemeDialog && (
                            <div className="p-mt-4">
                                <GSFSchemeSelect
                                    orderData={orderData}
                                    preOrderNo={preOrderData?.order_no}
                                    onClose={() => setOpenSchemeDialog(false)}
                                />
                            </div>
                        )} */}

                        </div>
                    </div >
                </div >
            ) : (
                <Dialog visible={openSchemeDialog} style={{ width: '900px' }} header={`Select Scheme`} modal className="p-fluid" footer={customerDialogFooter} onHide={hideDialog} maximizable={true} blockScroll={true}>
                    {/* <div className="card" style={{ width: "100%", minHeight: "600px", margin: "0 auto" }}> */}
                    <GSFSchemeSelect
                        orderData={orderData}
                        preOrderNo={preOrderData?._id}
                        openSchemeDialog={openSchemeDialog}
                    // onClick={() => setOpenSchemeDialog(false)}
                    />
                    {/* </div> */}
                </Dialog>
            )}
        </>
    )

}